import { FC, memo } from "react";

interface PencilProps {
    color?: string;
}

const Pencil: FC<PencilProps> = ({ color = "#51C2B9" }) => {
    return (
        <>
            <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="icon-pencil"
            >
                <rect width="40" height="40" rx="20" fill={color} />
                <path
                    d="M12.5 24.3751V27.5001H15.625L24.8417 18.2835L21.7167 15.1585L12.5 24.3751ZM27.2583 15.8668C27.5833 15.5418 27.5833 15.0168 27.2583 14.6918L25.3083 12.7418C24.9833 12.4168 24.4583 12.4168 24.1333 12.7418L22.6083 14.2668L25.7333 17.3918L27.2583 15.8668Z"
                    fill="black"
                />
            </svg>
        </>
    )
}

export default memo(Pencil)